import { render, staticRenderFns } from "./orderList2.vue?vue&type=template&id=5a7d2a8c&scoped=true"
import script from "./orderList2.vue?vue&type=script&lang=js"
export * from "./orderList2.vue?vue&type=script&lang=js"
import style0 from "./orderList2.vue?vue&type=style&index=0&id=5a7d2a8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a7d2a8c",
  null
  
)

export default component.exports